// extracted by mini-css-extract-plugin
export default {"wrapper":"Assets_wrapper__Lk8ux","left":"Assets_left__UxYab"};